export default __webpack_public_path__ + "static/media/I_Ilha.b002ea23.mp3";